import React, { useEffect, useState } from "react";
import {
  Grid,
  Card,
  CardContent,
  Divider,
  Button,
  IconButton,
  Menu,
  Tooltip,
  Box,
  Autocomplete,
  TextField,
} from "@mui/material";
import Label from "../../../components/Label/Label";
import "./newTaskStatus.scss";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";

import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import MoreVertOutlinedIcon from "@mui/icons-material/MoreVertOutlined";
import { styled } from "@mui/system";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllBatchTiles,
  getDrugTypeListBatchAndUserNames,
} from "../../../redux/investigation/actions";
import LogDrawer from "./LogDrawer";
import DashboardTableSkaleton from "../../../components/Skeletons/DashboardTableSkaleton";
import DatePicker from "react-datepicker";
import FilterListIcon from "@mui/icons-material/FilterList";
import DataPreviewDialog from "./DataPreviewDIalog";
import { investigatorRoutes } from "../../../routes/routeConstants";

const StatusDot = styled("div")(({ color }) => ({
  width: 12,
  height: 12,
  borderRadius: "50%",
  backgroundColor: color,
  margin: "0 7px",
}));

const StatusDots = ({ status }) => {
  const statusStages = [
    "Mapping",
    "Extraction",
    "Validation",
    "Approval",
    "Submitted",
  ];
  const getStatusColor = (currentStatus, statusIndex) => {
    const currentStatusIndex = statusStages.indexOf(currentStatus);

    if (currentStatus === "Submitted") {
      return "#20C157";
    } else if (statusIndex < currentStatusIndex) {
      return "#20C157";
    } else if (statusIndex === currentStatusIndex) {
      return "orange";
    } else {
      return "#CFCFCF";
    }
  };

  return (
    <Box display="flex" alignItems="center" paddingTop="10px">
      {statusStages.map((stage, idx) => (
        <StatusDot key={idx} color={getStatusColor(status, idx)} />
      ))}
    </Box>
  );
};

const RenderCard = ({ tile, selectedCardAndChipIndex, index, chipIndex }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();

  const [openLogDialog, setOpenLogDialog] = useState(false);
  const [openDataPreviewDialog, setOpenDataPreviewDialog] = useState(false);

  const [selectedDetails, setSelectedDetails] = useState();
  const handleInfoClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const onClickMenu = (tile, type) => {
    if (type === "audit_trail") {
      setOpenLogDialog(true);

      setSelectedDetails({
        ...tile,
        type: "batch",
      });
      setAnchorEl(null);
    } else if (type === "search") {
      navigate(`/${investigatorRoutes.investigationAnalysis}`, {
        state: {
          projectId: tile?.project_id,
          projectName: tile?.project_name,
        },
      });
    } else if (type === "data_preview") {
      setOpenDataPreviewDialog(true);
    }
  };

  const closeLogDrawer = () => {
    setOpenLogDialog(false);
  };

  const closeDataPreviewDrawer = () => {
    setOpenDataPreviewDialog(false);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <React.Fragment>
      <CardContent>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <Label text="Batch Name" fontSize="11px" />

          <div
            style={{
              display: "flex",
              flexDirection: "row",
              marginRight: "-15px",
            }}
          >
            <Tooltip
              title={
                tile?.batch_pdfs.length > 0 ? (
                  <div>
                    <Label
                      text="Uploaded Files:"
                      fontWeight="500"
                      fontSize="12px"
                      color="white"
                    />
                    {tile?.batch_pdfs?.map((batch, idx) => (
                      <div key={idx}>{batch}</div>
                    ))}
                  </div>
                ) : (
                  "Files not uploaded"
                )
              }
              placement="top"
              arrow
            >
              <IconButton size="small" style={{ padding: "0px" }}>
                <InfoOutlinedIcon size="small" />
              </IconButton>
            </Tooltip>
            <IconButton
              onClick={handleInfoClick}
              size="small"
              style={{ padding: "0px" }}
            >
              <MoreVertOutlinedIcon size="small" />
            </IconButton>
          </div>
        </div>

        <div
          style={{
            fontSize: "12px",
            fontWeight: 600,
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: 2,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "normal",
            maxWidth: "150px",
            cursor: "pointer",
            height: "32px",
            lineHeight: "16px",
            wordBreak: "break-all",
          }}
          title={tile?.batch_name}
        >
          {tile?.batch_name}
        </div>

        <Label text="Template Name" fontSize="11px" paddingTop="5px" />
        <div
          style={{
            fontSize: "12px",
            fontWeight: 600,
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: 2,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "normal",
            maxWidth: "150px",
            cursor: "pointer",
            height: "32px",
            lineHeight: "16px",
            wordBreak: "break-all",
          }}
          title={tile?.project_name}
        >
          {tile?.project_name}
        </div>

        <Divider style={{ margin: "10px 0px" }} />

        <Label text="Status" fontSize="11px" />
        <Label text={tile.batch_status} fontSize="12px" fontWeight="600" />

        <StatusDots status={tile.batch_status} />
      </CardContent>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        <MenuItem onClick={() => onClickMenu(tile, "audit_trail")}>
          Audit Trail
        </MenuItem>
        {/* <Divider /> */}
        {/* <MenuItem
          onClick={() => onClickMenu(tile, "search")}
          disabled={tile.batch_status !== "Submitted"}
        >
          Search
        </MenuItem> */}
        <Divider />
        <MenuItem
          onClick={() => onClickMenu(tile, "data_preview")}
          disabled={tile.batch_status !== "Submitted"}
        >
          Data Preview
        </MenuItem>
      </Menu>
      {
        <LogDrawer
          openLogDialog={openLogDialog}
          closeLogDrawer={closeLogDrawer}
          selectedDetails={selectedDetails}
        />
      }
      {openDataPreviewDialog && tile?.project_name && (
        <DataPreviewDialog
          openDataPreviewDialog={openDataPreviewDialog}
          closeDataPreviewDrawer={closeDataPreviewDrawer}
          projectName={tile?.project_name}
        />
      )}
    </React.Fragment>
  );
};

const BatchTiles = () => {
  const dispatch = useDispatch();

  const apiStatusGetAllBatchTiles = useSelector(
    (state) => state?.investigation?.apiStatusGetAllBatchTiles
  );

  const productTypesBatchAndUserNames = useSelector(
    (state) => state?.investigation?.productTypesBatchAndUserNames
  );

  const batchTilesData = useSelector(
    (state) => state?.investigation?.batchTilesData || []
  );

  const [products, setProducts] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [batches, setBatches] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState("");
  const [selectedBatch, setSelectedBatch] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("All");
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState("");
  const [tilesData, settilesData] = useState([]);
  const [dateRange, setDateRange] = useState([null, null]);

  const statuses = [
    "All",
    "Mapping",
    "Extraction",
    "Validation",
    "Approval",
    "Submitted",
  ];

  const today = new Date();
  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(today.getMonth() - 1);

  useEffect(() => {
    setInitialData(productTypesBatchAndUserNames);
  }, [productTypesBatchAndUserNames]);

  useEffect(() => {
    settilesData(batchTilesData);
  }, [batchTilesData]);

  useEffect(() => {
    dispatch(
      getAllBatchTiles({
        selectedProduct,
        selectedTemplate,
        selectedBatch,
        dateRange: [oneMonthAgo, today],
      })
    );
    setDateRange([oneMonthAgo, today]);
    dispatch(getDrugTypeListBatchAndUserNames());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const setInitialData = (productTypesBatchAndUserNames) => {
    if (productTypesBatchAndUserNames?.length) {
      const uniqueProducts = [
        ...new Set(
          productTypesBatchAndUserNames.map((item) => item.product_name)
        ),
      ];
      setProducts(uniqueProducts);

      const uniqueTemplates = [
        ...new Set(
          productTypesBatchAndUserNames.map((item) => item.template_name)
        ),
      ];
      setTemplates(uniqueTemplates);

      const uniqueBatches = [
        ...new Set(
          productTypesBatchAndUserNames.map((item) => item.batch_name)
        ),
      ];
      setBatches(uniqueBatches);
    }
  };

  const handleTemplateChange = (_, value) => {
    const selectedTemplate = value;
    setSelectedTemplate(selectedTemplate);
    setSelectedBatch("");

    const filteredBatches = productTypesBatchAndUserNames
      .filter((item) => item.template_name === selectedTemplate)
      .map((item) => item.batch_name);
    setBatches([...new Set(filteredBatches)]);

    const selectedItem = productTypesBatchAndUserNames.find(
      (item) => item.template_name === selectedTemplate
    );
    if (selectedItem) {
      setSelectedProduct(selectedItem.product_name);
    }
  };

  const handleProductChange = (_, value) => {
    const selectedProduct = value;
    setSelectedProduct(selectedProduct);
    setSelectedTemplate("");
    setSelectedBatch("");

    const filteredTemplates = productTypesBatchAndUserNames
      .filter((item) => item.product_name === selectedProduct)
      .map((item) => item.template_name);
    setTemplates([...new Set(filteredTemplates)]);

    const filteredBatches = productTypesBatchAndUserNames
      .filter((item) => item.product_name === selectedProduct)
      .map((item) => item.batch_name);
    setBatches([...new Set(filteredBatches)]);
  };

  const handleBatchChange = (_, value) => {
    const selectedBatch = value;
    setSelectedBatch(selectedBatch);

    const selectedItem = productTypesBatchAndUserNames.find(
      (item) => item.batch_name === selectedBatch
    );
    if (selectedItem) {
      setSelectedProduct(selectedItem.product_name);
      setSelectedTemplate(selectedItem.template_name);
    }
  };

  const onChangeDates = (update) => {
    setDateRange(update);
  };

  const onClickSearch = () => {
    dispatch(
      getAllBatchTiles({
        selectedProduct,
        selectedTemplate,
        selectedBatch,
        dateRange,
      })
    );
    setSelectedStatus("All");
  };

  const onClickClear = () => {
    setSelectedProduct("");
    setSelectedTemplate("");
    setSelectedBatch("");

    setProducts([]);
    setTemplates([]);
    setBatches([]);
    setDateRange([oneMonthAgo, today]);

    dispatch(
      getAllBatchTiles({
        selectedProduct: "",
        selectedTemplate: "",
        selectedBatch: "",
        dateRange: [oneMonthAgo, today],
      })
    );
    dispatch(getDrugTypeListBatchAndUserNames());
  };

  const handleStatusChange = (status) => {
    setSelectedStatus(status);
    setAnchorEl(null);

    const filteredData =
      status === "All"
        ? batchTilesData
        : batchTilesData?.filter((tile) => tile.batch_status === status);

    settilesData([...filteredData]);
  };

  return (
    <>
      <Grid container spacing={1} sx={{ paddingTop: "10px" }}>
        <Grid item xs={2}>
          <FormControl fullWidth size="small">
            <Autocomplete
              size="small"
              options={products || []}
              renderInput={(params) => (
                <TextField {...params} label="Product" />
              )}
              onChange={handleProductChange}
              value={selectedProduct}
            />
          </FormControl>
        </Grid>

        <Grid item xs={2}>
          <FormControl fullWidth size="small">
            <Autocomplete
              size="small"
              options={templates || []}
              renderInput={(params) => (
                <TextField {...params} label="Template" />
              )}
              onChange={handleTemplateChange}
              value={selectedTemplate}
            />
          </FormControl>
        </Grid>

        <Grid item xs={2}>
          <FormControl fullWidth size="small">
            <Autocomplete
              size="small"
              options={batches || []}
              renderInput={(params) => <TextField {...params} label="Batch" />}
              onChange={handleBatchChange}
              value={selectedBatch}
            />
          </FormControl>
        </Grid>

        <Grid item xs={2} className="DateRangePickerAudit">
          <DatePicker
            className="DateRangePickerNewLogs"
            placeholderText="DD-MMM-YYYY To DD-MMM-YYYY"
            selectsRange={true}
            startDate={dateRange[0]}
            endDate={dateRange[1]}
            onChange={(update) => {
              onChangeDates(update);
            }}
            isClearable={true}
            maxDate={new Date()}
          />
        </Grid>

        <Grid item xs={1}>
          <Button variant="contained" onClick={() => onClickSearch()}>
            Search
          </Button>
        </Grid>

        <Grid item xs={1}>
          <Button variant="outlined" onClick={() => onClickClear()}>
            Clear
          </Button>
        </Grid>

        <div
          style={{
            float: "right",
            marginLeft: "auto",
            marginRight: "20px",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <Label
            text={selectedStatus}
            fontSize="14px"
            fontWeight="500"
            paddingRight="5px"
          />
          <IconButton
            disabled={apiStatusGetAllBatchTiles?.loader}
            variant="text"
            size="small"
            onClick={(e) => setAnchorEl(e.currentTarget)}
          >
            <FilterListIcon />
          </IconButton>

          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={() => setAnchorEl(null)}
          >
            {statuses.map((status, idx) => (
              <MenuItem key={idx} onClick={() => handleStatusChange(status)}>
                {status}
              </MenuItem>
            ))}
          </Menu>
        </div>
      </Grid>

      {apiStatusGetAllBatchTiles?.loader ? (
        <DashboardTableSkaleton count={5} />
      ) : tilesData?.length > 0 ? (
        <Grid container spacing={1} style={{ paddingTop: "10px" }}>
          {tilesData?.map((tile, index) => (
            <Grid item key={index} style={{ paddingBottom: "10px" }}>
              <Card variant="outlined" className="task-status-batch-tiles">
                <RenderCard tile={tile} index={index} />
              </Card>
            </Grid>
          ))}
        </Grid>
      ) : (
        <div className="no-data">
          <Label
            text="No Data Found"
            fontSize="16"
            fontWeight="600"
            padding="20px"
          />
        </div>
      )}
    </>
  );
};

export default BatchTiles;
